// teeinblue_custom.js
(() => {
  const PROMPT = 'Select a Size to Continue';
  const LOCK = 'tib-size-lock';

  let chosen = false;
  let originalLabel = 'Add to Cart';
  let timer = 0;

  const sizeRoot = () => document.querySelector('.tee-option.tee-option--size:not(.sr-only)');
  const atc = () => document.querySelector('#teeAtcButton');
  const labelNode = (btn) =>
    btn?.querySelector('span:not(.loading__spinner):not(.spinner)') || btn;

  const stripDefault = () => {
    const root = sizeRoot();
    if (!root || chosen) return;
    root.querySelectorAll('.tee-radio.active').forEach((n) => n.classList.remove('active'));
    root.querySelectorAll('input[type="radio"]').forEach((r) => {
      if (r.checked) r.checked = false;
      r.removeAttribute('checked');
    });
  };

  const paintLock = () => {
    document.documentElement.classList.add(LOCK);
    const btn = atc();
    if (!btn || chosen) return;
    btn.setAttribute('data-tib-forced', 'true');
    const span = labelNode(btn);
    if (!span) return;
    if (!btn.dataset.tibOriginalLabel) {
      const t = span.textContent.trim();
      if (t && t !== PROMPT) btn.dataset.tibOriginalLabel = t;
    }
    if (span.textContent.trim() !== PROMPT) span.textContent = PROMPT;
  };

  const unlock = () => {
    chosen = true;
    clearInterval(timer);
    document.documentElement.classList.remove(LOCK);
    const btn = atc();
    if (!btn) return;
    btn.removeAttribute('data-tib-forced');
    const span = labelNode(btn);
    if (span) span.textContent = btn.dataset.tibOriginalLabel || originalLabel;
  };

  const startWatch = () => {
    if (timer) return;
    stripDefault();
    paintLock();
    // TeeInBlue re-renders the size row; beat it on a short interval
    // until the customer actually clicks a size.
    timer = setInterval(() => {
      if (chosen) {
        clearInterval(timer);
        return;
      }
      stripDefault();
      paintLock();
    }, 80);
  };

  document.addEventListener(
    'pointerdown',
    (e) => {
      if (chosen || !e.isTrusted) return;
      const root = sizeRoot();
      if (!root || !root.contains(e.target)) return;
      const radio = e.target.closest('.tee-radio');
      if (!radio) return;
      unlock();
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      if (chosen) return;
      const t = e.target;
      if (!(t instanceof Element)) return;
      const hittingAtc =
        t.closest('#teeAtcButton') ||
        t.closest('.tee-form-actions button') ||
        t.closest('.shopify-payment-button__button') ||
        t.closest('.shopify-payment-button__more-options');
      if (!hittingAtc) return;
      if (!sizeRoot()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      stripDefault();
      paintLock();
      sizeRoot().scrollIntoView({ block: 'center', behavior: 'smooth' });
    },
    true
  );

  document.addEventListener(
    'submit',
    (e) => {
      if (chosen) return;
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.querySelector('#teeAtcButton') && form.id !== 'tee-artwork-form') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      stripDefault();
      paintLock();
    },
    true
  );

  const boot = () => startWatch();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  new MutationObserver(boot).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

const getSizeChartUrl = () => {
  const titleEl = document.querySelector('.product__title h1, h1.product__title');
  const title = titleEl ? titleEl.textContent.trim() : '';

  const sizeChartMap = {
    'Personalized National Park Youth Shirt': 'https://cdn.shopify.com/s/files/1/0648/1454/7027/files/ComfortColors9018-SizeChart.jpg?v=1778367986',
    // add more product titles and URLs here as needed
     'Custom Park Shirt - Long Sleeves': 'https://cdn.shopify.com/s/files/1/0648/1454/7027/files/size-chart-comfort-colors-6014.jpg?v=1780263867',
     'Custom Park Shirt - Back Print - Long Sleeves':'https://cdn.shopify.com/s/files/1/0648/1454/7027/files/size-chart-comfort-colors-6014.jpg?v=1780263867'
  };

  // Return the matching URL or fall back to the default
  return sizeChartMap[title] || 'https://cdn.shopify.com/s/files/1/0648/1454/7027/files/comfort-colors-size-chart.jpg';
};

const checkSizeChartButton = () => {
  const sizeOptionTitle = document.querySelector('.tee-option--size:not(.sr-only) .tee-option__title');

  if (!sizeOptionTitle) {
    //console.log('Size option title not found yet');
    return;
  }
  
  // Check if we've already added the size chart link
  const existingLink = sizeOptionTitle.querySelector('.custom-size-chart-link');
  if (existingLink) {
    //console.log('Size chart link already exists');
    return;
  }

  // Create the size chart link element
  const sizeChartLink = document.createElement('a');
  sizeChartLink.className = 'custom-size-chart-link';
  sizeChartLink.href =  getSizeChartUrl();
  sizeChartLink.target = '_blank';
  sizeChartLink.rel = 'noopener noreferrer';
  sizeChartLink.style.cssText = 'margin-left: 8px; vertical-align: middle; display: inline-flex; align-items: center; gap: 0.4em; text-decoration: none; color: inherit;';
  sizeChartLink.title = 'View Size Chart';
  
  // Add the popup behavior (opens in new window instead of tab)
  sizeChartLink.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const width = 600;
    const height = 517;
    const left = (screen.width - width) / 2;
    const top = (screen.height - height) / 2;
    window.open(
      this.href, 
      'SizeChart', 
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
    return false;
  });
  
  // Create the icon image
  const icon = document.createElement('img');
  icon.src = 'https://cdn.shopify.com/s/files/1/0648/1454/7027/files/tape-measure.png?v=1750029810';
  icon.alt = 'Size Chart';
  icon.style.cssText = 'height: 2.0em; width: auto;';
  
  // Create the text span
  const text = document.createElement('span');
  text.textContent = 'Size chart + fit help';
  
  // Assemble the link
  sizeChartLink.appendChild(icon);
  sizeChartLink.appendChild(text);
  
  // Add to the size option title
  sizeOptionTitle.appendChild(sizeChartLink);
  
  //console.log('Size chart link added to TeeInBlue form');
}


// NEW FUNCTION: Add Loox review widget to TeeInBlue form
const addLooxReviewWidget = () => {
  const teeForm = document.querySelector('.tee-options');
  const looxWidget = document.querySelector('#shopify-block-AVVByZmw0ajg2TlowV__loox_reviews_loox_rating_wgkzaq');
  
  //console.log('Checking for elements...', {teeForm, looxWidget});
  
  if (teeForm && looxWidget) {
    // Check if we've already added it
    const existingLoox = teeForm.querySelector('.teeinblue-loox-reviews');
    if (!existingLoox) {
      //console.log('Adding Loox widget to TeeInBlue form');
      // Clone the Loox widget
      const looxClone = looxWidget.cloneNode(true);
      looxClone.classList.add('teeinblue-loox-reviews');
      
      // Insert at the very top of the form
      teeForm.insertBefore(looxClone, teeForm.firstChild);
    } else {
     // console.log('Loox widget already exists in form');
    }
  } else {
   // console.log('Elements not found yet');
  }
}

/* NEW FUNCTION: Add National Park Foundation badge
const addNPFBadge = () => {
  // Find the price block (which may have been moved)
  const priceBlock = document.querySelector('.tee-product-price');
  
  if (!priceBlock) {
   // console.log('Price block not found yet');
    return;
  }
  
  // Check if badge already added
  const existingBadge = document.querySelector('#secure-badge-tee');
  if (existingBadge) {
   // console.log('NPF badge already exists');
    return;
  }
  
  // Create the badge link
  const badge = document.createElement('a');
  badge.id = 'secure-badge-tee';
  badge.href = '/pages/protecting-our-parks';
  badge.className = 'secure-badge-tee';
  
  // Create the image
  const img = document.createElement('img');
  img.src = '//summitandsagetees.com/cdn/shop/files/tree_badge_2.png';
  img.alt = 'National Park Foundation Support Emblem';
  
  // Create the text span
  const span = document.createElement('span');
  span.textContent = 'Supports the National Park Foundation.';
  
  // Append elements
  badge.appendChild(img);
  badge.appendChild(span);
  
  // Insert after the price block (wherever it is)
  priceBlock.parentNode.insertBefore(badge, priceBlock.nextSibling);
  
  //console.log('NPF badge added after price block');
}
*/

// NEW FUNCTION: Move shipping pill below TeeInBlue price
const moveShippingPillBelowPrice = () => {
  const pillWrap = document.querySelector('#free-shipping-pill');
  const priceBlock = document.querySelector('.tee-product-price');

  if (!pillWrap || !priceBlock) {
   // console.log('Shipping pill or price block not found yet', { pillWrap, priceBlock });
    return;
  }

  // Avoid moving it multiple times
  if (pillWrap.classList.contains('shipping-pill-moved')) {
    return;
  }
  pillWrap.classList.add('shipping-pill-moved');

  // Insert directly AFTER the price
  priceBlock.parentNode.insertBefore(pillWrap, priceBlock.nextSibling);

  //console.log('Shipping pill moved below price');
};

// NEW FUNCTION: Move the Fitline block below TeeInBlue size options
const moveFitlineBelowSize_PREV = () => {
  // Your fitline block (the one you added via Custom Liquid)
  const fitline = document.querySelector('.ws-fitline');
  // TeeInBlue size option block
  const sizeOption = document.querySelector('.tee-option--size:not(.sr-only)');

  if (!fitline || !sizeOption) {
   // console.log('Fitline or size option not found yet', { fitline, sizeOption });
    return;
  }

  // Avoid moving it multiple times
  if (fitline.classList.contains('fitline-moved')) {
    return;
  }
  fitline.classList.add('fitline-moved');

  // Insert directly AFTER the size option
  sizeOption.parentNode.insertBefore(fitline, sizeOption.nextSibling);

  console.log('Fitline moved below size options');
};

// NEW FUNCTION: Move the Fitline block below TeeInBlue size options
const moveFitlineBelowSize = () => {
  // Your fitline block (the one you added via Custom Liquid)
  const fitline = document.querySelector('.fit-note');
  // TeeInBlue size option block
  const sizeOption = document.querySelector('.tee-option--size:not(.sr-only)');

  if (!fitline || !sizeOption) {
   // console.log('Fitline or size option not found yet', { fitline, sizeOption });
    return;
  }

  // Avoid moving it multiple times
  if (fitline.classList.contains('fitline-moved')) {
    return;
  }
  fitline.classList.add('fitline-moved');

  // Insert directly AFTER the size option
  sizeOption.parentNode.insertBefore(fitline, sizeOption.nextSibling);

  console.log('Fitline moved below size options');
};

// NEW FUNCTION: Move price block below size options
const movePriceBlock = () => {
  const priceBlock = document.querySelector('.tee-product-price');
  const sizeOption = document.querySelector('.tee-option--size');
  
  if (!priceBlock || !sizeOption) {
   // console.log('Price block or size option not found yet', {priceBlock, sizeOption});
    return;
  }
  
  // Check if price has already been moved (to avoid moving it multiple times)
  if (priceBlock.classList.contains('price-moved')) {
  //  console.log('Price block already moved');
    return;
  }
  
  // Mark as moved
  priceBlock.classList.add('price-moved');
  
  // Insert price block right after the size option
  sizeOption.parentNode.insertBefore(priceBlock, sizeOption.nextSibling);
  
 // console.log('Price block moved below size options');
}

// Helper: find the closest ancestor that is a flex row (usually qty + atc live here)
const findClosestFlexRow = (el, maxHops = 8) => {
  let node = el;
  for (let i = 0; i < maxHops && node; i++) {
    node = node.parentElement;
    if (!node) break;

    const cs = window.getComputedStyle(node);
    const isFlex = cs.display === 'flex' || cs.display === 'inline-flex';
    if (!isFlex) continue;

    // Heuristic: flex row contains the ATC button and also some other control
    const hasAtc = node.querySelector && node.querySelector('#teeAtcButton');
    if (hasAtc) return node;
  }
  return null;
};

const moveSizeChartAccordionAboveATC = () => {
  const atcButton = document.querySelector('#teeAtcButton');
  if (!atcButton) return;

  // Find the accordion block whose title is "SIZING: Structured Fit (Minimal Stretch)"
  const accordionBlocks = Array.from(document.querySelectorAll('.product__accordion.accordion'));
  const sizeChartAccordion = accordionBlocks.find((block) => {
    const titleEl = block.querySelector('.accordion__title');
    return titleEl && titleEl.textContent.trim().toLowerCase() === 'sizing: structured fit (minimal stretch)';
  });

  if (!sizeChartAccordion) return;

  // Avoid moving multiple times
  if (sizeChartAccordion.classList.contains('sizechart-accordion-moved-atc')) return;
  sizeChartAccordion.classList.add('sizechart-accordion-moved-atc');

  // ✅ Insert ABOVE the whole ATC flex row (qty + button), not inside it
  const atcFlexRow = findClosestFlexRow(atcButton);
  const anchor = atcFlexRow || atcButton;

  anchor.parentNode.insertBefore(sizeChartAccordion, anchor);

  // Ensure it behaves like its own row
  sizeChartAccordion.style.display = 'block';
  sizeChartAccordion.style.width = '100%';
};

// Force Qty to its own row and make ATC full width (personalized tee UX)
const enforceFullWidthATCLayout = () => {
  const atcButton = document.querySelector('#teeAtcButton');
  if (!atcButton) return;

  // Reuse your existing flex-row finder if you have it already
  const findClosestFlexRow = (el, maxHops = 8) => {
    let node = el;
    for (let i = 0; i < maxHops && node; i++) {
      node = node.parentElement;
      if (!node) break;

      const cs = window.getComputedStyle(node);
      const isFlex = cs.display === 'flex' || cs.display === 'inline-flex';
      if (!isFlex) continue;

      const hasAtc = node.querySelector && node.querySelector('#teeAtcButton');
      if (hasAtc) return node;
    }
    return null;
  };

  const atcFlexRow = findClosestFlexRow(atcButton);
  if (!atcFlexRow) return;

  // Add a stable class so CSS can target it
  atcFlexRow.classList.add('ws-tib-atc-row');

  // Try to tag the quantity control too (best-effort)
  // This works for most qty steppers: buttons with +/-, input[type=number], etc.
  const qtyCandidate =
    atcFlexRow.querySelector('input[type="number"]') ||
    atcFlexRow.querySelector('[class*="quantity"]') ||
    atcFlexRow.querySelector('button[aria-label*="increase" i]')?.closest('div') ||
    atcFlexRow.querySelector('button[aria-label*="decrease" i]')?.closest('div');

  if (qtyCandidate) qtyCandidate.classList.add('ws-tib-qty');

  // Also tag the button itself
  atcButton.classList.add('ws-tib-atc-button');
};

// New Function Enforce Size Selection
/*  -- Replaced at top of file --
const enforceSizeSelection = () => {
  const atcButton = document.querySelector('#teeAtcButton');
  if (!atcButton) return;

  const sizeOption = document.querySelector('.tee-option--size:not(.sr-only)');
  if (!sizeOption) return;

  // Already initialized
  if (atcButton.dataset.forcedSizeInit === 'true') return;
  atcButton.dataset.forcedSizeInit = 'true';

  const PROMPT_TEXT = 'Select a Size to Continue';
  let customerChoseSize = false;

  const getBtnSpan = (btn) =>
    btn.querySelector('span:not(.loading__spinner):not(.spinner)') || btn;
  const btnSpan = getBtnSpan(atcButton);
  //const originalLabel = btnSpan.textContent.trim();
  const originalLabel = btnSpan.textContent.trim() || 'Add to Cart';

  const lock = () => {
    atcButton.disabled = true;
    atcButton.setAttribute('data-forced-disabled', 'true');
    btnSpan.textContent = PROMPT_TEXT;
  };

  const unlock = () => {
    atcButton.removeAttribute('data-forced-disabled');
    atcButton.disabled = false;
    btnSpan.textContent = originalLabel;
  };

  lock();

  // Watch for size radio clicks
  sizeOption.addEventListener('change', (e) => {
  if (e.target.matches('input[type="radio"]') && !customerChoseSize) {
    customerChoseSize = true;
    unlock();
  }
});

  // Re-lock if TeeInBlue re-enables the button before a size is chosen
  const observer = new MutationObserver(() => {
    if (!customerChoseSize && !atcButton.disabled) {
      lock();
    }
  });
  observer.observe(atcButton, { attributes: true });
};
*/

// NEW FUNCTION: Add sizing message above Add to Cart button
const addSizingMessage = () => {
  const atcButton = document.querySelector('#teeAtcButton');
  
  if (!atcButton) {
   // console.log('Add to Cart button not found yet');
    return;
  }
  
  // Check if message already added
  const existingMessage = document.querySelector('.size-chart-reminder-tee');
  if (existingMessage) {
  //  console.log('Sizing message already exists');
    return;
  }
  
  // Create the sizing message
  const sizingMessage = document.createElement('p');
  sizingMessage.className = 'size-chart-reminder-tee';
  sizingMessage.innerHTML = '⚠️ All shirts are made to order. Please review the <b>size chart</b> before ordering. We do not offer returns or exchanges for sizing issues.';
  atcButton.parentNode.insertBefore(sizingMessage, atcButton);
  
//  console.log('Sizing message added above Add to Cart button');
}

const moveConfirmationCheckbox = () => {
  const checkbox = document.querySelector('.tee-checkbox-wrapper');
  const atcButton = document.querySelector('#teeAtcButton');

  if (!checkbox || !atcButton) return;
  if (checkbox.classList.contains('confirm-moved')) return;
  checkbox.classList.add('confirm-moved');

  atcButton.parentNode.insertBefore(checkbox, atcButton);
};

// NEW FUNCTION: Move the Delivery Estimate block right above the confirmation checkbox
const moveDeliveryEstimateAboveConfirmation = () => {
  const deliveryEstimate = document.querySelector('.delivery-estimate');
  const checkbox = document.querySelector('.tee-checkbox-wrapper');

  if (!deliveryEstimate || !checkbox) return;
  if (deliveryEstimate.classList.contains('delivery-estimate-moved')) return;
  deliveryEstimate.classList.add('delivery-estimate-moved');

  checkbox.parentNode.insertBefore(deliveryEstimate, checkbox);
};

// NEW FUNCTION: Add/update color selection display
const updateColorDisplay = () => {
  const colorContainer = document.querySelector('.tee-option--color');
  if (!colorContainer) return;
  
  // Hide the original COLOR title
  const titleElement = colorContainer.querySelector('.tee-option__title');
  if (titleElement) {
    titleElement.style.display = 'none';
  }
  
  // Find the selected color
  const selectedInput = colorContainer.querySelector('input[type="radio"]:checked');
  if (!selectedInput) return;
  
  const colorName = selectedInput.value;
  
  // Check if display already exists
  let colorDisplay = colorContainer.querySelector('.tee-color-display');
  
  if (!colorDisplay) {
    // Create the display element
    colorDisplay = document.createElement('div');
    colorDisplay.className = 'tee-color-display';
    // Match the styling from your image - bold, uppercase, with spacing
    colorDisplay.style.cssText = 'margin-bottom: 12px; font-weight: 700; color: #333; text-transform: uppercase; font-size: 1.5rem; letter-spacing: 0.05em;';
    
    // Insert at the top of the color container
    colorContainer.prepend(colorDisplay);
  }
  
  // Update the text - showing "COLOR: Color Name"
  colorDisplay.textContent = `COLOR: ${colorName}`;
 // console.log(`Updated color display to: ${colorName}`);
}

// NEW FUNCTION: Replace color pills with swatches
const replaceColorPillsWithSwatches = () => {
  // Only apply swatches on desktop (screen width > 768px)
  if (window.innerWidth <= 768) {
   // console.log('Mobile detected - skipping color swatch conversion');
    return;
  }
  
  const colorRadios = document.querySelectorAll('.tee-option--color .tee-radio--color');
  
  if (colorRadios.length === 0) {
 //   console.log('No color radios found yet');
    return;
  }
  
  // Color mapping from your theme settings
  const colorMap = {
    'Bay': '#94a596',
    'Ivory': '#e7ceb5',
    'Pepper': '#4e4b48',
    'Sage': '#3e4827',
    'Yam': '#be531c',
    'Blue Jean': '#647692',
    'Moss': '#6b7c5e',
    'Espresso': '#715a4e',
    'hemp':'#525b40',
    'Chalky Mint': '#82bfbb',
    'Mustard': '#eebe6f',
    'Butter': '#f5e1a4',
    'Grey':'#716e6a',
    'Chambray': '#bdd6e6',
    'Light Green':'#5c7f71',
    'Hemp':'#525b40',
    'Black':'#111111',
    'Graphite':'#27272a'
  };
  
  //console.log('Replacing color pills with swatches...');
  
  colorRadios.forEach(radio => {
    // Check if already converted
    if (radio.classList.contains('swatch-converted')) {
      return;
    }
    
    const input = radio.querySelector('input[type="radio"]');
    const label = radio.querySelector('label');
    const span = label ? label.querySelector('span') : null;
    
    if (!input || !label || !span) return;
    
    const colorName = input.value;
    const hexColor = colorMap[colorName];
    
    if (hexColor) {
      // Add converted class to prevent re-processing
      radio.classList.add('swatch-converted');
      
      // Store the hex color as a data attribute so CSS can use it
      label.setAttribute('data-swatch-color', hexColor);
      
      // Apply swatch styling - force square dimensions with !important
      const size = '34px';
      label.style.setProperty('width', size, 'important');
      label.style.setProperty('height', size, 'important');
      label.style.setProperty('min-width', size, 'important');
      label.style.setProperty('min-height', size, 'important');
      label.style.setProperty('max-width', size, 'important');
      label.style.setProperty('max-height', size, 'important');
      label.style.setProperty('flex', 'none', 'important');
      label.style.borderRadius = '100%';
      label.style.border = 'none';
      label.style.position = 'relative';
      label.style.cursor = 'pointer';
      label.style.display = 'block';
      label.style.margin = '0';
      label.style.padding = '0';
      
      // Force transparent background using setProperty with !important
      label.style.setProperty('background-color', 'transparent', 'important');
      label.style.setProperty('background', 'transparent', 'important');
      
      // Hide the text span
      span.style.display = 'none';
      span.classList.add('visually-hidden');
      
      // Add pseudo-element styling for borders (via class)
      label.classList.add('color-swatch-tee');
      
      // Add change event listener to update color display
      input.addEventListener('change', () => {
        updateColorDisplay();
      });
      
      // Set up a MutationObserver to watch for style changes on this label
      let observerTimeout;
      const labelObserver = new MutationObserver((mutations) => {
        // Debounce to reduce processing
        clearTimeout(observerTimeout);
        observerTimeout = setTimeout(() => {
          // Keep label at 34px always
          const targetSize = '34px';
          
          // Only update if actually different
          if (label.style.width !== targetSize || label.style.height !== targetSize) {
            label.style.setProperty('width', targetSize, 'important');
            label.style.setProperty('height', targetSize, 'important');
            label.style.setProperty('min-width', targetSize, 'important');
            label.style.setProperty('min-height', targetSize, 'important');
            label.style.setProperty('max-width', targetSize, 'important');
            label.style.setProperty('max-height', targetSize, 'important');
          }
          if (label.style.backgroundColor !== 'transparent') {
            label.style.setProperty('background-color', 'transparent', 'important');
            label.style.setProperty('background', 'transparent', 'important');
          }
        }, 10);
      });
      
      // Start observing the label for attribute changes
      labelObserver.observe(label, {
        attributes: true,
        attributeFilter: ['style']
      });
      
      // Add touch/click handler with debouncing
      let clickTimeout;
      const handleInteraction = () => {
        clearTimeout(clickTimeout);
        clickTimeout = setTimeout(() => {
          label.style.setProperty('width', '34px', 'important');
          label.style.setProperty('height', '34px', 'important');
          label.style.setProperty('flex', 'none', 'important');
        }, 50);
      };
      
      radio.addEventListener('click', handleInteraction, { passive: true });
      radio.addEventListener('touchend', handleInteraction, { passive: true });
      
     // console.log(`Converted ${colorName} to swatch with color ${hexColor}`);
    }
  });
  
  // After converting swatches, update the color display
  updateColorDisplay();
}

// Use MutationObserver to watch for when elements are added to the page
const observeForElements = () => {
  let debounceTimer;
  
  const observer = new MutationObserver((mutations) => {
    // Debounce to avoid running too frequently
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      // Check if TeeInBlue form exists
      const teeForm = document.querySelector('.tee-options');
      const looxWidget = document.querySelector('#shopify-block-AVVByZmw0ajg2TlowV__loox_reviews_loox_rating_wgkzaq');
      
      if (teeForm && looxWidget) {
        addLooxReviewWidget();
      }
      
      // Check for size chart
      checkSizeChartButton();
      
      // Move price block below sizes
      movePriceBlock();

      moveFitlineBelowSize();

      moveShippingPillBelowPrice();
      
      // Replace color pills with swatches - run immediately for color changes
      replaceColorPillsWithSwatches();
      
      // Add sizing message (re-add if missing)
    //  addSizingMessage();
      moveSizeChartAccordionAboveATC();

      // TEST!!
     // enforceSizeSelection();

      enforceFullWidthATCLayout();

      moveConfirmationCheckbox();

      moveDeliveryEstimateAboveConfirmation();
      
      // Add NPF badge (after a small delay to ensure price has moved)
     // setTimeout(() => {
     //   addNPFBadge();
     // }, 100);
    }, 50); // Reduced from 100ms to 50ms for faster response
  });

  // Start observing the document with configured parameters
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
 // console.log('MutationObserver started watching for TeeInBlue and Loox elements');
}

// Start observing when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeForElements);
} else {
  observeForElements();
}

// Also try with the original TeeInBlue events (in case they do fire)
document.addEventListener("teeinblue-event-variant-changed", () => {
//  console.log('TeeInBlue variant changed event fired');
  
  // Immediately re-apply swatches without delay
  replaceColorPillsWithSwatches();
  
  const checkElementRendered = setInterval(() => {
    const sizeTitle = document.querySelector('.tee-option--size:not(.sr-only) .tee-option__title');
    if (sizeTitle) {
      checkSizeChartButton();
      clearInterval(checkElementRendered);
    }
  }, 200);
  
  addLooxReviewWidget();
  //addSizingMessage();
  movePriceBlock();
  moveShippingPillBelowPrice();
  moveFitlineBelowSize();
  moveSizeChartAccordionAboveATC();
  // TEST!
 // enforceSizeSelection();
  enforceFullWidthATCLayout();
  moveConfirmationCheckbox();
  moveDeliveryEstimateAboveConfirmation();
  //addNPFBadge();

});

document.addEventListener("teeinblue-event-component-injected", () => {
 // console.log('TeeInBlue component injected event fired');
  
  // Immediately re-apply swatches without delay
  replaceColorPillsWithSwatches();
  
  const checkElementRendered = setInterval(() => {
    const sizeTitle = document.querySelector('.tee-option--size:not(.sr-only) .tee-option__title');
    if (sizeTitle) {
      checkSizeChartButton();
      clearInterval(checkElementRendered);
    }
  }, 200);
  
  addLooxReviewWidget();
  //addSizingMessage();
  movePriceBlock();
  moveFitlineBelowSize();
  moveSizeChartAccordionAboveATC();
  // TEST!
 // enforceSizeSelection();
  enforceFullWidthATCLayout();
  moveConfirmationCheckbox();
  moveDeliveryEstimateAboveConfirmation();
  //addNPFBadge();
})
